export const siteInfo = {
  name: 'po18阅读平台',
  tagline: '深受用户喜爱的内容阅读平台',
  description: 'po18是深受用户喜爱的内容阅读平台，提供海量优质小说、漫画、轻小说等内容资源。本导航站提供po18最新官方入口、备用地址及使用指南，帮助用户快速安全地访问po18。',
  officialUrl: 'https://www.po18.com',
  backupUrls: [
    'https://po18.net',
    'https://po18.org',
    'https://po18.cc',
  ],
  contactEmail: 'support@po18.com',
  foundedYear: '2018',
};

export const categories = [
  { slug: 'yanqing', name: '言情小说', icon: 'ri-heart-line', count: 1280 },
  { slug: 'xuanhuan', name: '玄幻奇幻', icon: 'ri-magic-line', count: 960 },
  { slug: 'dushi', name: '都市生活', icon: 'ri-building-line', count: 850 },
  { slug: 'lishi', name: '历史军事', icon: 'ri-ancient-gate-line', count: 620 },
  { slug: 'kehuan', name: '科幻灵异', icon: 'ri-rocket-line', count: 480 },
  { slug: 'youxi', name: '游戏竞技', icon: 'ri-gamepad-line', count: 390 },
  { slug: 'xuanli', name: '悬疑推理', icon: 'ri-search-eye-line', count: 350 },
  { slug: 'wuxia', name: '武侠仙侠', icon: 'ri-sword-line', count: 720 },
];

export const articles = [
  {
    id: 1,
    title: '《星辰大海》—— 一部跨越星河的浪漫史诗',
    slug: 'xingchen-dahai',
    category: 'yanqing',
    excerpt: '当人类文明迈入星际时代，一段跨越星系的爱情故事在浩瀚宇宙中悄然展开。作者以细腻的笔触描绘了未来世界中的人性光辉与情感纠葛。',
    content: `<p>当人类文明迈入星际时代，一段跨越星系的爱情故事在浩瀚宇宙中悄然展开。</p>
    <p>《星辰大海》讲述了一位来自地球的年轻女舰长林星辰，在执行深空探索任务时，意外与来自仙女座星系的外星文明使者相遇的故事。两个截然不同的文明在碰撞中产生火花，一段跨越种族、跨越星系的爱情由此展开。</p>
    <p>作者以细腻的笔触描绘了未来世界中的人性光辉与情感纠葛。故事不仅有宏大的星际背景设定，更有着打动人心的情感内核。林星辰作为一位独立坚强的女性角色，在面对未知文明时的勇敢与智慧，以及在爱情面前的柔软与坚持，都刻画得入木三分。</p>
    <p>小说中对于未来科技的想象也令人叹为观止：量子通讯、曲率驱动、戴森球……这些硬科幻元素与浪漫爱情故事的完美融合，让读者在感受科技魅力的同时，也被深深的情感所打动。</p>
    <p>自连载以来，《星辰大海》在po18平台上收获了超过500万次阅读和数十万条好评，被誉为"近年来最令人惊艳的科幻爱情小说"。多位读者表示："读完最后一章，我久久不能平静，仿佛自己也经历了一场星际之旅。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dreamy%20cosmic%20scene%20with%20twinkling%20stars%20and%20a%20distant%20galaxy%2C%20soft%20ethereal%20glow%20in%20warm%20rose%20and%20gold%20tones%2C%20minimalist%20composition%20with%20elegant%20silhouette%2C%20romantic%20atmosphere%2C%20clean%20background%2C%20editorial%20style&width=800&height=600&seq=article-cover-01&orientation=landscape',
    date: '2026-08-08',
    views: 5280000,
    author: '星辰作者',
    tags: ['科幻爱情', '星际', '浪漫', '长篇连载'],
  },
  {
    id: 2,
    title: '《长安旧事》—— 梦回大唐的权谋与爱恨',
    slug: 'changan-jiushi',
    category: 'lishi',
    excerpt: '以盛唐为背景，讲述了一位现代考古学家意外穿越到唐朝长安，卷入宫廷权谋与爱恨情仇的精彩故事。历史与虚构的完美交融。',
    content: `<p>以盛唐为背景，讲述了一位现代考古学家意外穿越到唐朝长安，卷入宫廷权谋与爱恨情仇的精彩故事。</p>
    <p>主人公苏长安是一位年轻的考古学博士，在西安大明宫遗址进行考古发掘时，意外触碰了一件神秘文物，灵魂穿越到了公元712年的长安城。彼时正值唐玄宗李隆基登基之初，朝堂之上暗流涌动，各方势力明争暗斗。</p>
    <p>苏长安凭借现代知识和对历史的了解，在危机四伏的大唐宫廷中周旋求生。她遇到了年轻时的唐玄宗、才子王维、将军高仙芝等历史人物，也在不经意间卷入了一场关乎大唐国运的惊天阴谋。</p>
    <p>小说对唐朝的服饰、饮食、建筑、礼仪等细节描写极为考究，让读者仿佛身临其境。作者查阅了大量历史文献，力求还原一个真实鲜活的盛唐长安。而故事中的权谋斗争、爱恨纠葛，更是让人欲罢不能。</p>
    <p>《长安旧事》在po18连载期间，连续三个月位居历史类排行榜榜首，被众多读者称为"最具代入感的穿越小说"。有读者评价："读这本书就像真的回到了唐朝，每一个场景都栩栩如生。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20palace%20with%20warm%20lantern%20light%2C%20traditional%20architecture%20silhouette%20at%20dusk%2C%20golden%20and%20crimson%20tones%2C%20elegant%20minimalist%20composition%2C%20historical%20atmosphere%2C%20clean%20background&width=800&height=600&seq=article-cover-02&orientation=landscape',
    date: '2026-08-05',
    views: 3890000,
    author: '长安故人',
    tags: ['历史穿越', '盛唐', '权谋', '长篇连载'],
  },
  {
    id: 3,
    title: '《灵气复苏：从校园开始》—— 都市玄幻热血力作',
    slug: 'lingqi-fusu',
    category: 'xuanhuan',
    excerpt: '一场神秘的灵气潮汐席卷全球，普通高中生林北辰意外觉醒超凡能力。在这个崭新的时代，他将如何守护所爱之人，揭开灵气复苏背后的真相？',
    content: `<p>一场神秘的灵气潮汐席卷全球，普通高中生林北辰意外觉醒超凡能力。</p>
    <p>公元2045年，一场被称为"灵气潮汐"的全球性现象彻底改变了世界格局。空气中弥漫着神秘的灵气，一部分人类开始觉醒各种超凡能力——有人能操控火焰，有人能读心透视，有人力大无穷。</p>
    <p>普通高中生林北辰原本只是江城一中一名成绩平平的学生，却在一次校园欺凌事件中突然觉醒了罕见的"吞噬"能力。这种能力让他可以吸收他人的灵气为己所用，但也因此被各方势力盯上。</p>
    <p>在这个崭新的时代，传统社会秩序被打破，觉醒者组织、政府机构、古老宗门纷纷浮出水面。林北辰在探索自身能力的过程中，逐渐发现灵气复苏背后隐藏着惊天的秘密——这场改变人类命运的潮汐，并非偶然。</p>
    <p>小说以校园为起点，逐步展开一个宏大的都市玄幻世界。热血战斗、校园日常、兄弟情义、青春恋爱等元素交织在一起，节奏紧凑，爽点密集。po18平台数据显示，该作品读者留存率高达87%，是平台最受欢迎的玄幻作品之一。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20school%20campus%20with%20mystical%20energy%20glowing%20particles%2C%20warm%20sunset%20light%2C%20fantasy%20elements%20blending%20with%20urban%20scene%2C%20dynamic%20composition%2C%20clean%20minimalist%20background%2C%20cinematic%20style&width=800&height=600&seq=article-cover-03&orientation=landscape',
    date: '2026-08-03',
    views: 4560000,
    author: '北冥有鱼',
    tags: ['玄幻', '都市', '热血', '校园'],
  },
  {
    id: 4,
    title: '《总裁的千亿新娘》—— 都市甜宠巅峰之作',
    slug: 'zongcai-qianyi',
    category: 'dushi',
    excerpt: '一场意外让普通女孩苏小暖与商业帝国总裁顾景琛相遇。从契约婚姻到真心相爱，这段甜到犯规的都市爱情故事让数百万读者为之倾倒。',
    content: `<p>一场意外让普通女孩苏小暖与商业帝国总裁顾景琛相遇。从契约婚姻到真心相爱，这段甜到犯规的都市爱情故事让数百万读者为之倾倒。</p>
    <p>苏小暖是一个在广告公司工作的普通女孩，性格开朗乐观。一天晚上，她在酒店走廊意外撞见了醉酒的顾氏集团总裁顾景琛。更意外的是，第二天她发现自己竟然成为了这位千亿总裁的"契约新娘"。</p>
    <p>原来，顾景琛为了应付家族逼婚，需要一个临时妻子。而苏小暖因为弟弟的医疗费用急需一笔钱。两人各取所需，签订了一年的契约婚姻。但谁也没想到，这场交易般的婚姻会演变成一段真挚的爱情。</p>
    <p>小说以轻松幽默的笔调描绘了这段反差极大的爱情故事。霸总的高冷外表下隐藏着温柔的内心，灰姑娘的平凡生活中闪耀着不平凡的勇气。两人在日常相处中逐渐靠近，误会与甜蜜交织，让读者笑中带泪。</p>
    <p>该作品在po18平台累计阅读量突破800万，评论数超过20万条。书评区每天都有大量读者催更，被粉丝们亲切地称为"最让人上头的甜宠文"。多位读者留言："看完只想说，顾总我可以！"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20city%20skyline%20at%20sunset%2C%20warm%20romantic%20golden%20light%2C%20luxury%20high-rise%20building%20reflection%2C%20soft%20dreamy%20atmosphere%2C%20minimalist%20composition%2C%20clean%20background%2C%20editorial%20style&width=800&height=600&seq=article-cover-04&orientation=landscape',
    date: '2026-07-28',
    views: 8120000,
    author: '暖风十里',
    tags: ['都市爱情', '甜宠', '总裁', '长篇完结'],
  },
  {
    id: 5,
    title: '《暗夜追踪》—— 悬疑推理烧脑神作',
    slug: 'anye-zhuizong',
    category: 'xuanli',
    excerpt: '一桩离奇的连环失踪案，将刑侦队长陆沉卷入一个精心设计的迷局。每一条线索都指向更深的黑暗，真相远比想象的更加骇人。',
    content: `<p>一桩离奇的连环失踪案，将刑侦队长陆沉卷入一个精心设计的迷局。</p>
    <p>深夜的江城市，连续三起失踪案件让整个城市笼罩在恐惧之中。所有失踪者之间看似毫无关联——一位大学教授、一名外卖骑手、一个中学生。但刑侦队长陆沉在调查中发现，这些人的手机上都在失踪前收到过同一条神秘信息。</p>
    <p>随着调查的深入，陆沉逐渐发现这并非普通的刑事案件。失踪者们都被卷入了一个名为"暗夜游戏"的神秘组织中。这个组织以高额奖金为诱饵，招募玩家参与一场致命游戏。而游戏的规则只有一个：活到最后。</p>
    <p>作者以严谨的推理逻辑构建了一个环环相扣的悬疑故事。每一个细节都可能是伏笔，每一个角色都可能另有身份。读者在跟随陆沉破案的过程中，不断被反转所震撼，直到最后一页才恍然大悟。</p>
    <p>该书在po18连载期间引发热烈讨论，读者们在评论区展开推理竞赛，试图比主角更早找出真相。平台数据显示，超过60%的读者在阅读过程中至少被"打脸"反转三次以上，被誉为"年度最佳悬疑小说"。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20city%20alley%20at%20night%20with%20single%20streetlight%20glow%2C%20noir%20atmosphere%2C%20foggy%20ambient%20light%2C%20suspenseful%20mood%2C%20minimalist%20composition%2C%20clean%20cinematic%20style%2C%20warm%20golden%20light%20contrast&width=800&height=600&seq=article-cover-05&orientation=landscape',
    date: '2026-07-25',
    views: 3450000,
    author: '夜不语',
    tags: ['悬疑推理', '刑侦', '烧脑', '完结'],
  },
  {
    id: 6,
    title: '《剑道苍穹》—— 仙侠世界的热血传奇',
    slug: 'jiandao-cangqiong',
    category: 'wuxia',
    excerpt: '少年叶凌云身怀绝世剑骨，却因家族被灭而流落江湖。在血与火的淬炼中，他将一步步踏上剑道巅峰，一剑破苍穹。',
    content: `<p>少年叶凌云身怀绝世剑骨，却因家族被灭而流落江湖。在血与火的淬炼中，他将一步步踏上剑道巅峰。</p>
    <p>苍穹大陆，万族林立，强者为尊。叶家曾是这片大陆上赫赫有名的剑道世家，却在十年前的一场浩劫中被神秘势力灭门。唯一的幸存者——年仅七岁的叶凌云被一位隐居的老剑客所救。</p>
    <p>十年后，叶凌云带着师父传授的剑法重出江湖。他发现自己的身体中隐藏着传说中的"天剑之骨"——一种万年难遇的剑道资质。这既是机缘，也是诅咒，因为那些灭他满门的势力，正在四处寻找这种剑骨的传人。</p>
    <p>小说以传统仙侠为骨架，融入了现代网文的快节奏叙事。主角的成长路线清晰，从弱小到强大的过程令人热血沸腾。战斗描写精彩纷呈，剑招的设计融合了东方哲学与美学，每一场对决都如同一场视觉盛宴。</p>
    <p>《剑道苍穹》在po18平台连载以来，长期占据仙侠类排行榜前三。其宏大的世界观和细腻的人物刻画吸引了大量忠实读者，被誉为"新派仙侠的代表之作"。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Majestic%20Chinese%20mountain%20peaks%20with%20floating%20clouds%20and%20golden%20sunrise%20light%2C%20traditional%20martial%20arts%20atmosphere%2C%20ethereal%20mist%2C%20elegant%20composition%2C%20warm%20tones%2C%20clean%20minimalist%20background%2C%20cinematic%20style&width=800&height=600&seq=article-cover-06&orientation=landscape',
    date: '2026-07-20',
    views: 4980000,
    author: '剑无尘',
    tags: ['仙侠', '剑道', '热血', '长篇连载'],
  },
  {
    id: 7,
    title: '《王者之路》—— 电竞少年的荣耀征途',
    slug: 'wangzhe-zhilu',
    category: 'youxi',
    excerpt: '从网吧少年到世界冠军，陈默的电竞之路充满了汗水与泪水。在最热门的MOBA游戏中，他要用实力证明：平凡人也能创造不平凡的传奇。',
    content: `<p>从网吧少年到世界冠军，陈默的电竞之路充满了汗水与泪水。</p>
    <p>在《巅峰对决》这款全球最热门的MOBA游戏中，陈默只是一个普通的"路人王"——在排位赛中表现出色，但从未参加过正式比赛。直到有一天，一支濒临降级的职业战队向他发出了试训邀请。</p>
    <p>面对家人的反对、同学的嘲笑、社会的偏见，陈默毅然选择追逐自己的电竞梦想。职业赛场远比排位赛残酷百倍——战术配合、心理博弈、舆论压力，每一样都是巨大的挑战。但正是这些挑战，让陈默一步步成长为真正的职业选手。</p>
    <p>小说真实还原了电竞行业的生态：艰苦的训练日常、激烈的比赛现场、团队的争吵与和解、粉丝的支持与质疑。作者本身就是一名资深电竞从业者，许多情节来源于真实的行业经历。</p>
    <p>该作品在po18平台开创了游戏竞技类小说的新高度，不仅吸引了大量游戏玩家读者，也让许多原本不了解电竞的读者感受到了这个行业的魅力。有读者评论："看完这本书，我终于理解了为什么那么多人热爱电竞。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20arena%20with%20colorful%20neon%20lights%20and%20holographic%20displays%2C%20dynamic%20gaming%20atmosphere%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20composition%2C%20cinematic%20style%2C%20professional%20esports%20venue&width=800&height=600&seq=article-cover-07&orientation=landscape',
    date: '2026-07-15',
    views: 2750000,
    author: '电竞小默',
    tags: ['游戏竞技', '电竞', 'MOBA', '热血'],
  },
  {
    id: 8,
    title: '《末世求生手册》—— 硬核科幻生存指南',
    slug: 'moshi-qiusheng',
    category: 'kehuan',
    excerpt: '一场突如其来的病毒席卷全球，感染者变异为嗜血怪物。退役特种兵赵寒带领一群幸存者，在废墟中建立起人类最后的希望堡垒。',
    content: `<p>一场突如其来的病毒席卷全球，感染者变异为嗜血怪物。退役特种兵赵寒带领一群幸存者，在废墟中建立起人类最后的希望堡垒。</p>
    <p>公元2035年，"X病毒"从某国际生物实验室泄露，以惊人的速度在全球蔓延。感染者会在72小时内完全丧失人性，变成只知杀戮的变异体。全球秩序瞬间崩溃，城市沦为废墟，文明摇摇欲坠。</p>
    <p>退役特种兵赵寒在末世降临的第一时间就做出了正确判断——带着家人躲进了提前准备好的安全屋。但这只是开始。食物、水源、药品、武器，每一样都需要冒着生命危险去获取。更危险的是，除了变异体，还有在末世中丧失了道德底线的人类。</p>
    <p>小说摒弃了常见的"系统流""异能流"末世套路，以极其硬核的写实风格展现了末日生存的残酷与希望。每一个生存细节都经过作者的精心考据——食物的保存方式、武器的改装方法、防御工事的建造技巧，都有现实依据。</p>
    <p>该作品在po18平台上线后，迅速成为科幻类最受欢迎的作品之一。读者评价："这不是一本小说，这是末日生存教科书。"其真实感和紧张感让无数读者熬夜追读。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20cityscape%20with%20abandoned%20buildings%20and%20overgrown%20vegetation%2C%20warm%20sunset%20light%20breaking%20through%20clouds%2C%20survival%20atmosphere%2C%20cinematic%20composition%2C%20clean%20background%2C%20hopeful%20tone%20amid%20desolation&width=800&height=600&seq=article-cover-08&orientation=landscape',
    date: '2026-07-10',
    views: 3120000,
    author: '寒江独钓',
    tags: ['科幻', '末世', '生存', '硬核'],
  },
];

export const featuredArticles = [1, 2, 3, 4];

export const faqItems = [
  {
    question: 'po18是什么平台？',
    answer: 'po18是一个深受用户喜爱的综合性内容阅读平台，提供海量优质小说、漫画、轻小说等数字阅读内容。平台汇聚了众多优秀作者和作品，涵盖言情、玄幻、都市、历史、科幻等多种类型，为用户提供丰富的阅读选择。',
  },
  {
    question: '如何找到po18最新官方入口？',
    answer: 'po18最新官方入口地址为 www.po18.com。建议您收藏本导航页面，我们会实时更新po18的最新地址信息。同时，您也可以关注po18官方社交媒体账号获取最新动态。如果主入口无法访问，可以尝试使用我们提供的备用地址。',
  },
  {
    question: 'po18有哪些备用网址？',
    answer: 'po18提供了多个备用访问地址，包括 po18.net、po18.org、po18.cc 等。当主站因网络波动或服务器维护无法访问时，您可以通过这些备用地址正常登录和使用po18平台的全部功能。',
  },
  {
    question: 'po18怎么进入？打不开怎么办？',
    answer: '如果遇到po18无法打开的情况，可以尝试以下方法：1）清除浏览器缓存和Cookie后重试；2）切换网络环境（如从WiFi切换到移动数据）；3）使用po18备用地址访问；4）检查本地DNS设置；5）联系您的网络服务提供商确认是否有访问限制。',
  },
  {
    question: 'po18平台有什么内容？',
    answer: 'po18平台拥有海量的优质内容资源，涵盖言情小说、玄幻奇幻、都市生活、历史军事、科幻灵异、游戏竞技、悬疑推理、武侠仙侠等八大分类。平台月活跃作者超过5000人，日均更新量超过3000章节，满足不同读者的阅读偏好。',
  },
  {
    question: 'po18平台需要付费吗？',
    answer: 'po18平台采用免费+付费相结合的运营模式。大量优质内容可以免费阅读，部分独家精品内容需要购买会员或按章节付费。平台定期推出各种优惠活动和限时免费阅读计划，让更多读者享受到优质内容。',
  },
  {
    question: '如何在po18上找到好看的小说？',
    answer: '在po18平台上，您可以通过多种方式找到心仪的作品：1）浏览分类排行榜，查看各类型热门作品；2）使用搜索功能按关键词查找；3）查看编辑精选推荐；4）参考读者评分和书评；5）关注您喜欢的作者获取新作通知。',
  },
  {
    question: 'po18支持哪些设备阅读？',
    answer: 'po18平台支持全设备阅读体验，包括：PC网页端、手机移动网页端、iOS客户端、Android客户端。所有设备之间的阅读进度和书架收藏自动同步，让您可以随时随地畅享阅读。',
  },
];

export const aboutContent = {
  intro: {
    title: '关于po18',
    paragraphs: [
      'po18成立于2018年，是国内领先的综合性数字阅读平台。我们致力于为广大读者提供丰富、优质、便捷的数字阅读服务，让每一个人都能随时随地享受阅读的乐趣。',
      '经过多年的发展，po18已成长为拥有数千万注册用户的大型阅读社区。平台汇聚了超过5000名活跃作者，累计收录作品超过10万部，日均更新量超过3000章节，内容涵盖言情、玄幻、都市、历史、科幻、游戏、悬疑、武侠等多个品类。',
      '我们始终坚持以用户为中心，不断优化产品体验，丰富内容生态。通过智能推荐算法、个性化书架、社区互动等功能，po18为每位读者打造专属的阅读空间。',
    ],
  },
  reputation: {
    title: '用户口碑',
    items: [
      {
        name: '阅读爱好者小王',
        text: '用po18三年了，平台的更新速度真的很快，每天都有新内容可以看。推荐的算法也很准，总能找到我喜欢的小说。',
        rating: 5,
      },
      {
        name: '资深书虫老李',
        text: '作为一个看了十几年小说的人，po18的内容质量确实不错。尤其是一些新人作者的作品，很有新意。平台对作者的扶持也做得很好。',
        rating: 5,
      },
      {
        name: '大学生小陈',
        text: '最喜欢po18的夜间模式和字体调节功能，晚上看小说眼睛不累。而且跨设备同步做得很好，手机上看到一半，电脑上打开就能接着看。',
        rating: 5,
      },
      {
        name: '上班族张女士',
        text: '通勤路上必看po18，离线下载功能太好用了。在地铁上信号不好的时候也能看，而且分类很细，找书特别方便。',
        rating: 4,
      },
      {
        name: '自由职业者刘先生',
        text: 'po18的社区氛围很好，读者之间可以交流心得，还能和作者互动。有时候作者会根据读者反馈调整剧情，参与感很强。',
        rating: 5,
      },
    ],
    stats: [
      { label: '注册用户', value: '3000万+' },
      { label: '活跃作者', value: '5000+' },
      { label: '收录作品', value: '10万+' },
      { label: '日均更新', value: '3000+' },
      { label: '好评率', value: '96.8%' },
      { label: '应用评分', value: '4.8/5.0' },
    ],
  },
};

export const usageGuideSteps = [
  {
    step: 1,
    title: '访问入口',
    description: '通过本页面提供的最新官方入口或备用地址访问po18平台',
    icon: 'ri-link',
  },
  {
    step: 2,
    title: '注册账号',
    description: '使用手机号或邮箱免费注册po18账号，即可开始阅读之旅',
    icon: 'ri-user-add-line',
  },
  {
    step: 3,
    title: '浏览分类',
    description: '按分类浏览海量作品，或使用搜索功能找到心仪的内容',
    icon: 'ri-search-line',
  },
  {
    step: 4,
    title: '开始阅读',
    description: '选择喜欢的作品，享受流畅舒适的阅读体验',
    icon: 'ri-book-open-line',
  },
];